import React from 'react';
import {NavLink, Layout, Route, Settings, Switch, List, Collaboration} from 'components';
import {config} from 'helpers';

export function Router({ location: { pathname } }) {
  return (
    <>
      <Layout.Title>Settings</Layout.Title>
      <Layout.Topbar.Tabs>
        <NavLink exact={Boolean(pathname.match(/\bsharing\b/))} to="/settings/">Settings</NavLink>
        <NavLink to="/settings/sharing/">Sharing Dashboard</NavLink>
      </Layout.Topbar.Tabs>
      <Switch>
        <Route path="*/sharing/:id?" component={Collaboration.Dashboard} />
        <Route>
          <Layout.Sidebar className="smaller">
            <List className="link-list">
              <NavLink to="/settings/" exact>General</NavLink>
              <NavLink to="/settings/password/">Password</NavLink>
              <NavLink to="/settings/export/">Export</NavLink>
              <NavLink to="/settings/calendar-sync/">Google Calendar Sync</NavLink>
              <NavLink to="/settings/membership/">Membership</NavLink>
              <NavLink to="/settings/whats-new/">What's New</NavLink>
              <NavLink to="/settings/delete-account/">Delete Account</NavLink>
              <a target="_blank" href={`https://${config.appHost}/terms/`}>Terms</a>
              <a target="_blank" href={`https://${config.appHost}/privacy/`}>Privacy Policy</a>
            </List>
          </Layout.Sidebar>
          <main>
            <Switch>
              <Route path="*/membership/status/" component={Settings.MembershipStatus} />
              <Route path="*/membership/:upgraded(upgraded)/" component={Settings.Membership} />
              <Route path="*/membership/" component={Settings.Membership} />
              <Route path="*/delete-account/" component={Settings.DeleteAccount} />
              <Route path="*/calendar-sync/" component={Settings.CalendarSync} />
              <Route path="*/export/" component={Settings.Export} />
              <Route path="*/password/" component={Settings.Password} />
              <Route path="*/whats-new/" component={Settings.WhatsNew} />
              <Route component={Settings.General} />
            </Switch>
          </main>
        </Route>
      </Switch>
    </>
  );
}
